// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import vueVimeoPlayer from 'vue-vimeo-player'
import VueTheMask from 'vue-the-mask'
import carousel from 'v-owl-carousel'
import VueProgressBar from 'vue-progressbar'

// css and scss files include
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueI18n from 'vue-i18n'
import {createI18n} from 'vue-i18n-composable'
import './assets/css/font-awesome.min.css'
import './assets/index.scss'
import enMessages from './locales/en.json'
import ukMessages from './locales/uk.json'

Vue.use(VueI18n)
Vue.use(VueTheMask)
Vue.use(BootstrapVue)
Vue.use(vueVimeoPlayer)
Vue.component('carousel', carousel)

const VueInputMask = require('vue-inputmask').default
Vue.use(VueInputMask)
const i18n = createI18n({
  locale: (localStorage.getItem('lang') || 'uk'), // set locale
  fallbackLocale: 'en',
  messages: {
    'en': enMessages,
    'uk': ukMessages
  }
}
)
Vue.config.productionTip = false
const options = {
  color: '#00a3f5',
  failedColor: '#00a3f5',
  thickness: '4px',
  transition: {
    speed: '0.5s',
    opacity: '0.10s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
}
Vue.use(VueProgressBar, options)

export const vues = new Vue()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  i18n,
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js